<template>
	<div class="cube-chart-adpater">
		<ve-bar-chart v-if="type === 'bar'" :data="chartData" :settings="barSettings" :height="height" />
		<ve-line-chart v-if="type === 'line'" :data="chartData" :settings="lineSettings" :height="height" ref="chart" />
	</div>
</template>

<script>
	import dayjs from "dayjs";
	// import EnumClass from '../../../../util/cube/CompanyEnum.js';
	// import Statistic from "./Statistic.vue";

	export default {
		name: "ChartAdpater",
		components: {
			// Statistic,
		},
		props: {
			title: String,
			resultSet: {
				type: Object,
				required: true,
			},
			type: String, // 图表类型
			height: Number,
			yjz: {
				type: String,
				default: "",
			}, //预警值
			companyName: {
				type: String,
				default: "",
			}, //名

		},
		data() {
			return {
				chartData: [], // 图表数据
				lineSettings: {}, // 折线图配置项
				barSettings: {}, // 柱状图配置项
			};
		},
		computed: {
			// 系列名称
			seriesNames() {
				return this.resultSet.seriesNames();
			},
			// 度量
			metrics() {
				if (this.loading) return [""];
				return this.seriesNames.map((x) => x.key.split(",").shift());
			},
			// 规范化的查询结果
			chartPivot() {
				if (this.loading) return [];
				return this.resultSet.chartPivot();
			},
			// 统计指标数值
			statValue() {
				return parseFloat(this.chartPivot[0][this.metrics[0]]);
			},
		},
		mounted() {
			let dimensionsData = [];
			const measuresData = [];
			this.seriesNames.forEach((e) => {
				const data = this.chartPivot.map((v) => v[e.key]);
				// data.unshift(null);
				// data.push(null);
				measuresData.push({
					name: e.key.split(",").shift(),
					data,
				});
				dimensionsData = this.chartPivot.map((v) => dayjs(v.x).format("YYYY-MM"));
				// dimensionsData.unshift('');
				// dimensionsData.push('');
			});
			// 构建 ve-charts 数据项
			const chartData = {
				dimensions: {
					name: "DateTime",
					data: dimensionsData,
				},
				measures: measuresData,
			};
			this.chartData = chartData;
			this.lineSettings = {
				// label: {
				// 	show: true,
				// 	fontSize: '12',
				// 	fontWeight: 'bold'
				// },
				// grid: {
				// 	left: '10%',
				// 	right: '20%',
				// 	bottom: '30%',
				// 	containLabel: true
				// },
				// smooth: true,
				// showMaxLabel: true,
				// xAxisName: '月份',
				// xAxis: {
				// 	boundaryGap: true,
				// },
			};
			this.barSettings = {
				stack: {
					sum: ["Products.count", "Suppliers.count"],
				},
			};
			this.$nextTick(() => {
				// 获取图表实例
				const chartInstance = this.$refs.chart;
				chartInstance.initOptions;
				// console.log(chartInstance.options.series)
				// console.log(chartInstance.options);
				// console.log(chartInstance);
				chartInstance.options.grid = {
					left: '5%',
					right: '5%',
					bottom: '5%',
					containLabel: true
				};
				if (this.yjz != undefined && this.yjz != '') {
					let markLinelei = this.yjz.split('~')
					//添加虚线
					chartInstance.options.series.forEach(e => {
						e.markLine = {
							label: {
								formatter: '{c}', // 显示标签内容为数据值
							},
							symbol: 'none',
							data: []
						}
						markLinelei.forEach(v => {
							e.markLine.data.push({
								yAxis: v,
								name: '预警值',
								lineStyle: {
									color: '#E02020'
								},

							})
						})

					})
				}

				// 修改x轴的boundaryGap属性为false
				//   chartInstance.setOption({
				//     xAxis: {
				//       boundaryGap: true,
				//     },
				// });
				chartInstance.options.xAxis.boundaryGap = true;
				// 修改对应的图表公司名称，这里需要配置才能使用

				chartInstance.options.series.map((e) => {
					const label = e.name;
					// const value = EnumClass.getCompanyValue(label)
					const value = this.companyName
					if (value != undefined) {
						e.name = value;
					}
				})
				// console.log(chartInstance.options);
			})

		},
	};
</script>

<style>
</style>